<template>
  <div class="home w3-center">
    <img alt="CMDLab" src="../assets/logo_vector.svg">
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <h1>this is home page</h1>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'home',
  components: {
    HelloWorld
  }
}
</script>
